import PropTypes from 'prop-types';
import React from 'react';

import { i18n } from '@international/mastodon-i18n';
import { getScreeningStatusAndAssessment, hasAssessment } from '../utils';
import Panel from '../../../Panels';
import Record from '../Record';

const Search = ({
  search,
  showFilteredByAdjudicationRecords,
  title,
  type,
  dataTestId,
  assessmentEnabled,
  useScreeningStatusOverAssessment,
  status,
}) => {
  if (!search || search.status === 'canceled') {
    return null;
  }

  let recordsToDisplay = search.records || [];

  if (showFilteredByAdjudicationRecords) {
    recordsToDisplay = recordsToDisplay.concat(
      search.filteredByPositiveAdjudicationRecords || [],
    );
  }

  const { searchStatus, statusType, secondaryStatus } =
    getScreeningStatusAndAssessment(
      assessmentEnabled,
      useScreeningStatusOverAssessment,
      search,
      status,
    );

  return (
    <Panel
      data-testid={dataTestId}
      title={title}
      status={searchStatus}
      statusType={statusType}
      secondaryStatus={secondaryStatus}
    >
      {dataTestId === 'global-watchlist-searches' &&
        (search.displayedSources && search.displayedSources.length > 0 ? (
          <div className='text'>
            <b>
              {i18n.getStr(
                'components.globalWatchlistSearch.disclosureSourcesLabel',
              )}
            </b>
            <ul className='cds--list--unordered mastodon-unordered-list'>
              {search.displayedSources.map(source => (
                <li key={source} className='cds--list__item mastodon-list-item'>
                  {source}
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <b className='text'>
            {i18n.getStr('components.globalWatchlistSearch.disclosure')}
          </b>
        ))}
      {Array.isArray(search.records) &&
        recordsToDisplay.map((record, i) => (
          <Record
            key={record.id}
            record={record}
            index={i}
            type={type}
            assessmentEnabled={assessmentEnabled && hasAssessment(search)}
          />
        ))}
    </Panel>
  );
};

Search.propTypes = {
  search: PropTypes.object,
  showFilteredByAdjudicationRecords: PropTypes.bool,
  title: PropTypes.string,
  type: PropTypes.string,
  dataTestId: PropTypes.string,
  assessmentEnabled: PropTypes.bool,
  useScreeningStatusOverAssessment: PropTypes.bool,
  status: PropTypes.string,
};

Search.defaultProps = {
  search: null,
  showFilteredByAdjudicationRecords: false,
  title: '',
  type: '',
  dataTestId: '',
  assessmentEnabled: false,
  useScreeningStatusOverAssessment: false,
  status: null,
};

export default Search;
